import { render } from "./TableGeneric.vue?vue&type=template&id=3b562e96"
import script from "./TableGeneric.vue?vue&type=script&lang=ts"
export * from "./TableGeneric.vue?vue&type=script&lang=ts"

import "./TableGeneric.vue?vue&type=style&index=0&id=3b562e96&lang=scss"
script.render = render

export default script